export default __webpack_public_path__ + "static/media/03.2cc88d40.jpg";